import serverVars from 'server-vars';
import { trackEvent, eventNameConstants } from 'dibs-tracking';
import { AbTestV2Type } from '../../server/authentication/dalAuthentication';

export function getAbTestV2(testName: string): AbTestV2Type | null {
    if (typeof window === 'undefined') {
        throw new Error('getAbTestV2 should only be called on the client!');
    }
    return serverVars.get('abTestsV2.' + testName) || null;
}

export function trackAbTestV2Variant(testName: string): void {
    const abTest = getAbTestV2(testName);
    if (abTest) {
        trackEvent({
            category: 'a/b testing v3',
            eventName: eventNameConstants.EVENT_AB_TESTING,
            action: testName,
            interaction_type: testName,
            label: abTest?.variant,
            step_interaction_name: abTest.variant || undefined,
            value: abTest?.config?.ramp || undefined,
        });
    }
}
